import { render, staticRenderFns } from "./CompanyBranchsTable.vue?vue&type=template&id=3ceb707a"
import script from "./CompanyBranchsTable.vue?vue&type=script&lang=js"
export * from "./CompanyBranchsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports